import { useState } from 'react';
import { Form } from 'react-bootstrap';

const ReactstrapFormikFloatingLabelInput = ({
  field,
  form: { touched, errors, setFieldTouched },
  label,
  id,
  className,
  inputClassName,
  accountNameNote,
  rightIcon,
  ...props
}) => {
  const [isFocused, setFocus] = useState(false);

  const handleFocus = () => setFocus(true);
  const handleBlur = () => {
    setFocus(false);
    setFieldTouched(field.name, true);
  };

  const floatLabel = isFocused || field.value;

  return (
    <Form.Group className={`${className || ''} outlined-floating-input ${rightIcon ? 'has-right-icon' : ''}`}>
      <div className="input-wrapper floating-label-input-wrapper">
        <Form.Control
          {...field}
          {...props}
          onFocus={handleFocus}
          onBlur={handleBlur}
          isInvalid={Boolean(touched[field.name] && errors[field.name])}
          className={`${inputClassName || ''} ${rightIcon ? 'with-icon' : ''} floating-label-input`}
        />
        {label && (
          <label className={`floating-label ${floatLabel ? 'floating' : ''}`} htmlFor={id}>
            {label}
          </label>
        )}
        {rightIcon && <img src={rightIcon} alt="icon" className="input-right-icon" />}
      </div>

      {touched[field.name] && errors[field.name] && errors[field.name] !== 'required' && (
        <Form.Control.Feedback type="invalid" className="pb-0 invalid-feedback d-block">
          {errors[field.name]}
        </Form.Control.Feedback>
      )}

      {accountNameNote && <span className="pb-0 invalid-feedback d-block">{accountNameNote}</span>}
    </Form.Group>
  );
};

export default ReactstrapFormikFloatingLabelInput;
